import { NodeProps } from 'reactflow'
import { useShallow } from 'zustand/react/shallow'

import { QueryBuilder } from '@ui/components/elements/QueryBuilder'
import {
  AssignDestination,
  AssignSources,
  CodeEditor,
  CreateNode,
  LiveSample,
  TransformationCode,
  TransformationSteps,
} from '@ui/pages/pipelinesWorkflow/components/PipelineLayoutContent'
import { useLayoutPanelManagerStore, useQueryBuilderStore } from '@ui/stores/pipelinesWorkflow'

import { LayoutPanel, LEFT_PANEL_CONTENT, RIGHT_PANEL_CONTENT } from '../PipelineLayoutManager/interface'

export const PanelContentManager = ({
  node,
  panelContent,
}: {
  panelContent: LEFT_PANEL_CONTENT | RIGHT_PANEL_CONTENT | null
  node: NodeProps
}) => {
  const { setPanelContent, togglePanel } = useLayoutPanelManagerStore(
    useShallow((state) => ({
      setPanelContent: state.setPanelContent,
      togglePanel: state.togglePanel,
    }))
  )

  const { setShowOverlay } = useQueryBuilderStore(
    useShallow((state) => ({
      setShowOverlay: state.setShowOverlay,
    }))
  )

  const closeQueryBuilder = () => {
    setPanelContent({
      panel: LayoutPanel.INNER_RIGHT_PANEL,
      content: null,
      open: false,
    })
    setShowOverlay(false)
  }

  const handlePanelContent = (content: LEFT_PANEL_CONTENT | RIGHT_PANEL_CONTENT) => {
    switch (content) {
      /*************
       * Left Panel
       *************/
      case LEFT_PANEL_CONTENT.INSIGHTS:
        return (
          <div className="relative flex h-full w-full flex-col justify-between" data-testid="left-panel-content">
            <div>Insights</div>

            <button
              className="w-full cursor-pointer bg-red-500"
              onClick={() => togglePanel(LayoutPanel.LEFT_PANEL, false)}>
              Close
            </button>
          </div>
        )
      case LEFT_PANEL_CONTENT.LIVE_SAMPLE:
        return <LiveSample />
      /*************
       * Right Panel
       *************/
      case RIGHT_PANEL_CONTENT.ADD_NODE:
        return <CreateNode />
      case RIGHT_PANEL_CONTENT.TRANSFORMATION_STEPS:
        return <TransformationSteps node={node} />
      case RIGHT_PANEL_CONTENT.TRANSFORMATION_CODE:
        return <TransformationCode node={node} />
      case RIGHT_PANEL_CONTENT.SOURCES:
        return <AssignSources />
      case RIGHT_PANEL_CONTENT.DESTINATIONS:
        return <AssignDestination />
      case RIGHT_PANEL_CONTENT.CODE_EDITOR:
        return <CodeEditor node={node} />
      case RIGHT_PANEL_CONTENT.QUERY_BUILDER:
        return <QueryBuilder closePanel={closeQueryBuilder} />
      default:
        return null
    }
  }

  return (
    <div className="size-full" data-testid={`panel-content-manager-${panelContent}`}>
      {panelContent && handlePanelContent(panelContent)}
    </div>
  )
}
